// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.proxyList_proxy_container__zO-LJ {
  width: 100%;
}
@media screen and (max-width: 781px) {
  .proxyList_proxy_container__zO-LJ {
    border: none;
  }
}
@media screen and (max-width: 1660px) {
  .proxyList_proxy_container__zO-LJ {
    padding: 19px 5px;
  }
}
.proxyList_proxy_container__zO-LJ .proxyList_proxy_option__IeJfY {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  margin-top: 23px;
  margin-bottom: 15px;
}
.proxyList_proxy_container__zO-LJ .proxyList_proxy_option__IeJfY span {
  color: var(--font-color);
  font-family: Red Hat Display;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 36px;
  margin-left: 10px;
  margin-right: auto;
}
@media screen and (max-width: 1600px) {
  .proxyList_proxy_container__zO-LJ .proxyList_proxy_option__IeJfY span {
    font-size: 18px;
    margin-left: 6px;
  }
}
.proxyList_proxy_container__zO-LJ .proxyList_proxy_option__IeJfY button {
  line-height: 16px !important;
}
@media screen and (max-width: 1770px) {
  .proxyList_proxy_container__zO-LJ .proxyList_proxy_option__IeJfY button {
    width: 110px !important;
  }
}
@media screen and (max-width: 781px) {
  .proxyList_proxy_container__zO-LJ .proxyList_proxy_option__IeJfY button {
    right: 0;
    margin-top: 17px;
  }
}
.proxyList_proxy_container__zO-LJ .proxyList_proxy_option__IeJfY button svg {
  top: 35%;
}
.proxyList_proxy_container__zO-LJ .proxyList_proxy_option__IeJfY button:last-child {
  margin-left: 9px;
}
.proxyList_proxy_container__zO-LJ .proxyList_proxy_option__IeJfY button:last-child svg {
  top: 13%;
}
@media screen and (max-width: 1600px) {
  .proxyList_proxy_container__zO-LJ .proxyList_proxy_option__IeJfY button:last-child {
    width: 120px !important;
  }
}
.proxyList_proxy_container__zO-LJ .proxyList_proxy_list__-4ple {
  overflow-y: auto;
  overflow-x: hidden;
  max-height: 422px;
}
.proxyList_proxy_container__zO-LJ .proxyList_proxy_list__-4ple .proxyList_proxy__BnK6m {
  width: 100%;
  height: auto;
  min-height: 55px;
  border: 1px solid var(--re-border-color);
  border-radius: 10px;
  display: flex;
  margin-bottom: 10px;
  padding: 8px 16px;
  align-items: center;
}
.proxyList_proxy_container__zO-LJ .proxyList_proxy_list__-4ple .proxyList_proxy__BnK6m span {
  color: var(--font-dark-color);
  font-family: Red Hat Display;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  margin-right: auto;
}
.proxyList_proxy_container__zO-LJ .proxyList_proxy_list__-4ple .proxyList_proxy__BnK6m img {
  cursor: pointer;
}
.proxyList_proxy_container__zO-LJ .proxyList_proxy_list__-4ple::-webkit-scrollbar {
  width: 6px;
  height: 10px;
}
.proxyList_proxy_container__zO-LJ .proxyList_proxy_list__-4ple::-webkit-scrollbar-thumb {
  background: linear-gradient(316deg, #ffa329 4.43%, #fe7b1c 56.59%, #fc2a01 150.36%);
}
.proxyList_proxy_container__zO-LJ .proxyList_proxy_list__-4ple::-webkit-scrollbar-track {
  background-color: var(--bg-color);
}`, "",{"version":3,"sources":["webpack://./src/components/Layouts/proxyList/proxyList.module.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;AACF;AAAE;EAFF;IAGI,YAAA;EAGF;AACF;AADE;EANF;IAOI,iBAAA;EAIF;AACF;AAFE;EACE,WAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AAIJ;AAFI;EACE,wBAAA;EACA,4BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;AAIN;AAFM;EAVF;IAWI,eAAA;IACA,gBAAA;EAKN;AACF;AAFI;EACE,4BAAA;AAIN;AAFM;EAHF;IAII,uBAAA;EAKN;AACF;AAHM;EAPF;IAQI,QAAA;IACA,gBAAA;EAMN;AACF;AAJM;EACE,QAAA;AAMR;AAFI;EACE,gBAAA;AAIN;AAFM;EACE,QAAA;AAIR;AADM;EAPF;IAQI,uBAAA;EAIN;AACF;AAAE;EACE,gBAAA;EACA,kBAAA;EACA,iBAAA;AAEJ;AAAI;EACE,WAAA;EACA,YAAA;EACA,gBAAA;EACA,wCAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,mBAAA;AAEN;AAAM;EACE,6BAAA;EACA,4BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;AAER;AACM;EACE,eAAA;AACR;AAIE;EACE,UAAA;EACA,YAAA;AAFJ;AAKE;EACE,mFAAA;AAHJ;AAWE;EACE,iCAAA;AATJ","sourcesContent":[".proxy_container {\n  width: 100%;\n  @media screen and (max-width: 781px) {\n    border: none;\n  }\n\n  @media screen and (max-width: 1660px) {\n    padding: 19px 5px;\n  }\n\n  .proxy_option {\n    width: 100%;\n    display: flex;\n    flex-wrap: wrap;\n    margin-top: 23px;\n    margin-bottom: 15px;\n\n    span {\n      color: var(--font-color);\n      font-family: Red Hat Display;\n      font-size: 20px;\n      font-style: normal;\n      font-weight: 700;\n      line-height: 36px;\n      margin-left: 10px;\n      margin-right: auto;\n\n      @media screen and (max-width: 1600px) {\n        font-size: 18px;\n        margin-left: 6px;\n      }\n    }\n\n    button {\n      line-height: 16px !important;\n\n      @media screen and (max-width: 1770px) {\n        width: 110px !important;\n      }\n\n      @media screen and (max-width: 781px) {\n        right: 0;\n        margin-top: 17px;\n      }\n\n      svg {\n        top: 35%;\n      }\n    }\n\n    button:last-child {\n      margin-left: 9px;\n\n      svg {\n        top: 13%;\n      }\n\n      @media screen and (max-width: 1600px) {\n        width: 120px !important;\n      }\n    }\n  }\n\n  .proxy_list {\n    overflow-y: auto;\n    overflow-x: hidden;\n    max-height: 422px;\n\n    .proxy {\n      width: 100%;\n      height: auto;\n      min-height: 55px;\n      border: 1px solid var(--re-border-color);\n      border-radius: 10px;\n      display: flex;\n      margin-bottom: 10px;\n      padding: 8px 16px;\n      align-items: center;\n\n      span {\n        color: var(--font-dark-color);\n        font-family: Red Hat Display;\n        font-size: 16px;\n        font-style: normal;\n        font-weight: 600;\n        line-height: normal;\n        margin-right: auto;\n      }\n\n      img {\n        cursor: pointer;\n      }\n    }\n  }\n\n  .proxy_list::-webkit-scrollbar {\n    width: 6px;\n    height: 10px;\n  }\n\n  .proxy_list::-webkit-scrollbar-thumb {\n    background: linear-gradient(\n      316deg,\n      #ffa329 4.43%,\n      #fe7b1c 56.59%,\n      #fc2a01 150.36%\n    );\n  }\n\n  .proxy_list::-webkit-scrollbar-track {\n    background-color: var(--bg-color);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"proxy_container": `proxyList_proxy_container__zO-LJ`,
	"proxy_option": `proxyList_proxy_option__IeJfY`,
	"proxy_list": `proxyList_proxy_list__-4ple`,
	"proxy": `proxyList_proxy__BnK6m`
};
export default ___CSS_LOADER_EXPORT___;
